import { gql } from '@apollo/client'

// eslint-disable-next-line import/prefer-default-export
export const GET_USER_VOTE = gql`
  query GetUserVote (
        $contentId: Int!,
        $contentType: String!
    ) {
    contentList(
        where: {
            contentId: { eq: $contentId },
            contentType: { eq: $contentType }
        }
    ) {
        content {
            id
            vote {
                id
                voteDirection
            }
        }
    }
}
`
